import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Service from "../../service";
import "./publicCareerPage.css";

const PAGE_TITLE = "Welcome to WeekMate HRMS Portal";

const assetUrl = (path) => (path && /^https?:\/\//i.test(path) ? path : path ? `${Service.Server_Base_URL}/${path}` : null);

/**
 * Chrome shared by every public careers page: branded sticky header, content
 * area and footer. Lives entirely outside the authenticated app shell.
 */
const PublicCareerLayout = ({ companyslug, branding, hero, children }) => {
  const [logoBroken, setLogoBroken] = useState(false);
  const companyName = branding?.companyName || "";
  const logoUrl = assetUrl(branding?.companyLogoUrl);
  const faviconUrl = assetUrl(branding?.companyFavIcoUrl) || "/HrmsLogo2.svg";

  return (
    <div className="career-page">
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <link rel="icon" href={faviconUrl} />
      </Helmet>
      <header className="career-header">
        <Link to={`/${companyslug}/careers`} className="career-brand" aria-label={`${companyName} careers`}>
          {logoUrl && !logoBroken ? (
            <img className="career-logo" src={logoUrl} alt={companyName} onError={() => setLogoBroken(true)} />
          ) : null}
          <span className="career-brand-name">{companyName}</span>
        </Link>
      </header>
      {hero ? (
        <section className="career-hero">
          <div className="career-hero-inner">{hero}</div>
        </section>
      ) : null}
      <main className="career-content">{children}</main>
    </div>
  );
};

export default PublicCareerLayout;
